import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LayoutShell } from '../shared/Layout.tsx';
import { CambiarClavePage } from '../shared/CambiarClave.tsx';
import { ConvocatoriasPage } from './Convocatorias.tsx';
import { MiAgendaPage } from './MiAgenda.tsx';
import { MiDisponibilidadPage } from './MiDisponibilidad.tsx';
import { AsistenciaPage } from './Asistencia.tsx';
import { HistorialPersonalPage } from './HistorialPersonal.tsx';
import { activarPushSiPuede } from '../shared/push.ts';
import { MisPagosPage } from './MisPagos.tsx';
import { AyudaPersonalPage } from './Ayuda.tsx';

const nav = [
  { to: '/personal', label: 'Convocatorias', icon: 'check_circle' },
  { to: '/personal/agenda', label: 'Mi agenda', icon: 'calendar_month' },
  { to: '/personal/asistencia', label: 'Asistencia', icon: 'clock' },
  { to: '/personal/disponibilidad', label: 'Disponibilidad', icon: 'clock' },
  { to: '/personal/pagos', label: 'Mis pagos', icon: 'payments' },
  { to: '/personal/historial', label: 'Historial', icon: 'calendar_month' },
];

export function PersonalApp() {
  useEffect(() => {
    activarPushSiPuede();
  }, []);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <LayoutShell
            titulo="App Personal"
            items={nav}
            accent="azul"
            ayudaTo="/personal/ayuda"
            cuentaTo="/personal/cuenta"
          />
        }
      >
        <Route index element={<ConvocatoriasPage />} />
        <Route path="agenda" element={<MiAgendaPage />} />
        <Route path="asistencia" element={<AsistenciaPage />} />
        <Route path="disponibilidad" element={<MiDisponibilidadPage />} />
        <Route path="pagos" element={<MisPagosPage />} />
        <Route path="historial" element={<HistorialPersonalPage />} />
        <Route path="ayuda" element={<AyudaPersonalPage />} />
        <Route path="cuenta" element={<CambiarClavePage />} />
      </Route>
    </Routes>
  );
}
